import styled from 'styled-components';

import Social from '@r1-frontend/ui-react/components/buttons/social';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import ControlElement from '@r1-frontend/ui-react/components/typography/controlElement';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import TextWrapper from '@r1-frontend/ui-react/components/typography/TextWrapper';
import { BlockContainer } from '@r1-frontend/ui-react/experimental/containers';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

export const Grid = styled.div`
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    grid-template-rows: auto;
    gap: 32px;
    width: 100%;
    
    @media ((max-width: ${wideBreakpoints.sDesktop}) and (min-width: ${wideBreakpoints.laptop})) {
        grid-template-rows: minmax(166px, max-content);
    }
    
    @media (max-width: ${wideBreakpoints.mobile}) {
        gap: 24px;
    }
`;

export const Support = styled(BlockContainer)`
    grid-column: 1 / span 3;
    grid-row: 1 / 1;
    flex-direction: column;
    align-items: flex-start;

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        grid-column: 1 / span 4;
    }

    @media (max-width: ${wideBreakpoints.laptop}) {
        grid-column: 1 / span 6;
    }
    
    @media (max-width: ${wideBreakpoints.mobile}) {
        grid-column: 1 / -1;
    }
`;

export const Socials = styled(BlockContainer)`
    grid-column: 4 / span 3;
    grid-row: 1 / 1;
    flex-direction: column;

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        grid-column: 1 / span 4;
        grid-row: 2 / span 1;
    }

    @media (max-width: ${wideBreakpoints.laptop}) {
        grid-column: 7 / -1;
        grid-row: 1 / 1;
    }
    
    @media (max-width: ${wideBreakpoints.mobile}) {
        grid-column: 1 / -1;
        grid-row: 2 / span 1;
    }
`;

export const Callback = styled(BlockContainer)`
    grid-column: 1 / span 6;
    grid-row: 2 / span 1;

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        grid-column: 1 / -1;
        grid-row: auto;
    }
`;

export const App = styled(BlockContainer)`
    position: relative;
    grid-column: 7 / -1;
    grid-row: 1 / span 2;
    min-height: 364px;

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        grid-column: 5 / -1;
        grid-row: 1 / span 2;
    }

    @media (max-width: ${wideBreakpoints.laptop}) {
        grid-column: 1 / -1;
        grid-row: 2 / auto;
    }
    
    @media (max-width: ${wideBreakpoints.mobile}) {
        grid-row: auto;
        padding-bottom: 248px;
    }
`;

export const SControlElement = styled(ControlElement)`
    transition: color 0.25s;

    &:hover {
        color: ${COLORS.ButtonAccent};
    }
`;

export const SocialsList = styled(Social)`
    column-gap: 8px;
    li > a {
        width: 40px;
        height: 40px;
        padding: 3px;
        opacity: 1;
        &:hover {
            background-color: ${COLORS.Outline_Light};
        }
    }
    
    li > a > img {
        width: 33px;
        height: 33px;
        max-width: 100%;
        max-height: 100%;
    }
`;

export const ImageWrapper = styled.div`
    position: absolute;
    right: 0;
    bottom: 0;
    width: 502px;

    img, picture {
        display: block;
        width: 100%;
    }

    @media ((max-width: ${wideBreakpoints.laptop}) and (min-width: ${wideBreakpoints.tablet})) {
        left: 354px;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        right: 50%;
        transform: translate3d(50%, 0,0);
        width: 340px;
    }
`;

export const AppContent = styled.div`
    flex-direction: column;
    flex-wrap: nowrap;
    max-width: 320px;

    @media (max-width: ${wideBreakpoints.mobile}) {
        max-width: unset;
    }
`;


export const TextContent = styled(TextWrapper)`
    ${Paragraph4} {
        margin-bottom: 24px;
    }
`;
